import { render } from "./manageFleet.vue?vue&type=template&id=78d8119c"
import script from "./manageFleet.vue?vue&type=script&lang=js"
export * from "./manageFleet.vue?vue&type=script&lang=js"

import "./manageFleet.vue?vue&type=style&index=0&id=78d8119c&lang=scss"

import exportComponent from "C:\\Users\\DELL\\source\\repos\\project0810frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])